<template>
<fragment>
<div class="login-page">
    <div class="form">
        <form class="login-form" @submit.prevent="handleSubmit">
            <p class="message">System</p>
            <select id="loginSystem" name="loginSystem" v-model="loginSystem">
                <option disabled value="">Please select a system</option>
                <option value="WLDPTM">WLDPTM</option>
                <option value="GSPN">GSPN</option>
                <option value="SUPPORT">SUPPORT</option>
                <option value="SCMS">SCMS</option>
                <option value="CS">CS</option>
            </select>
            <p class="message">Login Information</p>
            <input type="text" name="loginIdManual" v-model="loginId" required autofocus>
            <select id="loginId" name="loginId" @change="loginId=$event.target.value" >
                <option disabled value="">Select One</option>
                <option value=" ">[ ] </option>
                <option value=" ">[ ] </option>
                <option value=" ">[ ] </option>
                <option value=" ">[ ] </option>
            </select>
            <input id="loginPwd" name="loginPwd" type="password" placeholder="password" v-model="loginPwd" required />
            <input id="loginType" name="loginType" type="hidden" v-model="loginType" />
            <input id="loadMenuKind" name="loadMenuKind" type="hidden" v-model="loadMenuKind" />
            <button type="submit">LOGIN</button>
        </form>
    </div>
</div>
</fragment>
</template>

<script>
import Vue                      from 'vue';
import {mapActions, mapGetters} from 'vuex';
import axios                    from 'axios';
import store                    from '@/vuex/store';
// import SDLUtil                  from '@/utils/SDLUtil';
import { SDLUtil, MenuUtil }    from '@/utils';
import loginService             from '@/service/skpLoginService';

export default {
    name: 'LoginFromOtherSystem',
    data() {
        return {
            loginId: ' ',
            loginPwd: 'password',
            loginSystem: 'WLDPTM',
            loginType: 'F',
            loadMenuKind: ''
        };
    },
    computed: {
        ...mapGetters({
            menus: 'getMenus',
        }),
        getLoginUser() {
            return SDLUtil.getLoginedUserInfo();
        },
        getUserLoginSystem() {
            const loginUser = this.getLoginUser || {};
            return loginUser['loginSystem'] || '';
        },
    },
    methods: {
        ...mapActions(['directLogin', 'logout']),
        async handleSubmit() {
            SDLUtil.showLoadingBar(true);
            // SDLUtil.alert({ msg: 'sdp.currency.exchRate.gdatu' });
            this.submitted = true;
            const { loginId, loginPwd, loginSystem, loginType, loadMenuKind } = this;

            if (loginId && loginPwd && loginSystem) {
                this.loadMenuKind = (loginSystem == 'SUPPORT') ? 'SUP' : 'ALL';
                let loginData = {
                    loginId: this.loginId,
                    loginPwd: this.loginPwd,
                    loginSystem: this.loginSystem,
                    loginType: 'F',
                    loadMenuKind: this.loadMenuKind
                };
                const loginResult = await this.directLogin(loginData)
                    .catch(err => {
                        SDLUtil.showLoadingBar(false);
                        SDLUtil.errorAlert(err);
                    });

                this.afterLoginProcess(loginResult);
            }
        },
        afterLoginProcess(loginResult) {
            if (loginResult) this.gotoMain();
            SDLUtil.showLoadingBar(false);
        },
        gotoMain() {
            const redirect = this.$route.query.redirect || '';
            if (redirect) {
                Vue.$log.info('＃ DirectLogin.vue redirect => ', redirect);
                this.$router.push({ path: `${SDLUtil.WEB_CONTEXT_PATH}`+`${redirect}` });
            } else {
                if(this.loginSystem == 'SUPPORT') {
                    this.$router.push(MenuUtil.getSupportMain());
                } else {
                    this.$router.push({ path: `${SDLUtil.WEB_CONTEXT_PATH}/main` });
                }
            }


        }
    },
    created() {
        if (SDLUtil.isLogin()) {
            this.gotoMain();

        } else if (this.$route.params.loginId) {
            // Automatically enter the ID you entered when you passed the membership registration
            this.loginId = this.$route.params.loginId;
        }
    },
    mounted() {

    },
    watch: {
        errorState() {
            alert(this.errorState.code);
            this.$router.push({ path: `${SDLUtil.WEB_CONTEXT_PATH}/error` });
        },
    },
};
</script>

<style scoped>
    @import url(https://fonts.googleapis.com/css?family=Roboto:300);

    .login-page {
        width: 360px;
        padding: 8% 0 0;
        margin: auto;
    }
    .form {
        position: relative;
        z-index: 1;
        background: #FFFFFF;
        max-width: 360px;
        margin: 0 auto 100px;
        padding: 45px;
        text-align: center;
        box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2), 0 5px 5px 0 rgba(0, 0, 0, 0.24);
    }
    .form select {
        font-family: "Roboto", sans-serif;
        outline: 0;
        background: #f2f2f2;
        width: 100%;
        border: 0;
        margin: 0 0 15px;
        height: 47px;
        line-height: normal;
        padding: 15px!important;
        box-sizing: border-box;
        font-size: 14px;
    }
    .form input {
        font-family: "Roboto", sans-serif;
        outline: 0;
        background: #f2f2f2;
        width: 100%;
        border: 0;
        margin: 0 0 15px;
        padding: 15px;
        box-sizing: border-box;
        font-size: 14px;
    }
    .form button {
        font-family: "Roboto", sans-serif;
        text-transform: uppercase;
        outline: 0;
        background: #28292d;
        width: 100%;
        border: 0;
        padding: 15px;
        color: #FFFFFF;
        font-size: 18px;
        font-weight: 700;
        -webkit-transition: all 0.3 ease;
        transition: all 0.3 ease;
        cursor: pointer;
    }
    .form .message {
        margin: 0 0 5px 0;
        color: #b3b3b3;
        font-size: 12px;
    }
    .form .message a {
        color: #4CAF50;
        text-decoration: none;
    }
    .form button:hover,.form button:active,.form button:focus {
        background: #808080;
    }
    body {
        background: #76b852; /* fallback for old browsers */
        background: -webkit-linear-gradient(right, #76b852, #8DC26F);
        background: -moz-linear-gradient(right, #76b852, #8DC26F);
        background: -o-linear-gradient(right, #76b852, #8DC26F);
        background: linear-gradient(to left, #76b852, #8DC26F);
        font-family: "Roboto", sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }
</style>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/login/LoginFromOtherSystem.vue